import { Provider } from '@angular/core';

import { SearchRepositoryImpl } from '@app/data/repositories/search/search.repository';
import { SEARCH_REPOSITORY } from '@app/domain/repositories/search/search.repository.contract';

export const searchRecordRepositoryProvider: Provider = {
  provide: SEARCH_REPOSITORY,
  useClass: SearchRepositoryImpl
};
